import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icon from '~/Common-Objects/UI/Icon'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import './index.scss'
import { cn } from '~/utils/cn'

const PanelHeader = ({ title, subtitle, searchPlaceholder, onSearch, onBack, hideBorder = false }) => {
    return (
        <div className={cn('panel-header', hideBorder && 'panel-header--no-border')}>
            {onBack && (
                <Button
                    className='button-ghost button-sml panel-header-back'
                    onClick={() => {
                        onBack()
                    }}
                    iconLeft={<Icon name='arrow-left' width={18} height={18} />}
                >
                    Done
                </Button>
            )}
            <h4 className='panel-header-title'>{title}</h4>
            {subtitle && <div className='panel-header-text'>{subtitle}</div>}
            {onSearch && (
                <div className='panel-header-search'>
                    <TextInput
                        iconLeft={<Icon name='magnifier' width='18' height='18' />}
                        type='text'
                        name='element-search'
                        placeholder={searchPlaceholder || i18n.t('searchEllipsis')}
                        onChange={onSearch}
                    />
                </div>
            )}
        </div>
    )
}

export default PanelHeader
